/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  BlockAgentOnConnectionForm,
  BlockAgentOnConnectionForm$Outbound,
  BlockAgentOnConnectionForm$outboundSchema,
} from "../components/blockagentonconnectionform.js";

export type BlockAgentOnConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type BlockAgentOnConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  blockAgentOnConnectionForm: BlockAgentOnConnectionForm;
};

/** @internal */
export type BlockAgentOnConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const BlockAgentOnConnectionSecurity$outboundSchema: z.ZodMiniType<
  BlockAgentOnConnectionSecurity$Outbound,
  BlockAgentOnConnectionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function blockAgentOnConnectionSecurityToJSON(
  blockAgentOnConnectionSecurity: BlockAgentOnConnectionSecurity,
): string {
  return JSON.stringify(
    BlockAgentOnConnectionSecurity$outboundSchema.parse(
      blockAgentOnConnectionSecurity,
    ),
  );
}

/** @internal */
export type BlockAgentOnConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  BlockAgentOnConnectionForm: BlockAgentOnConnectionForm$Outbound;
};

/** @internal */
export const BlockAgentOnConnectionRequest$outboundSchema: z.ZodMiniType<
  BlockAgentOnConnectionRequest$Outbound,
  BlockAgentOnConnectionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    blockAgentOnConnectionForm: BlockAgentOnConnectionForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      blockAgentOnConnectionForm: "BlockAgentOnConnectionForm",
    });
  }),
);

export function blockAgentOnConnectionRequestToJSON(
  blockAgentOnConnectionRequest: BlockAgentOnConnectionRequest,
): string {
  return JSON.stringify(
    BlockAgentOnConnectionRequest$outboundSchema.parse(
      blockAgentOnConnectionRequest,
    ),
  );
}
